// 🚀 Custom Magic: Unleashing the power of metafield variants in a product form popup, handcrafted with ❤️ for Durex India by the Fozail Ahmed! 🧙‍♂️

if (!customElements.get("product-form-popup")) {
  customElements.define(
    "product-form-popup",
    class ProductFormPopup extends ProductForm {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.popupButton = this.querySelector('button[data-button-type="variant"]');
        this.popupWrapper = document.querySelector("variant-popup");

        // Save the initial load state of the product variant popup
        this.initialSectionHTML = this.popupWrapper.innerHTML;

        this.popupButton.addEventListener("click",this.showVariantsPopup.bind(this));
      }

      initalizeVariantsPopup() {
        // Reintializing the load state for the product variant popup
        this.popupWrapper.innerHTML = this.initialSectionHTML;
        document.body.classList.add("overflow-hidden","popup-overlay");
        // Remove ONLY the inline overflow-y property from body
        document.body.style.removeProperty('overflow-y');

        this.popupWrapper.classList.add("active-popup");
      }

      calculatePopupContainerHeight() {
        this.variantPopup = document.querySelector("variant-popup");
        this.titleContainer = this.variantPopup.querySelector("variant-title-container");

        if (!(this.variantPopup && this.titleContainer)) return;
        const variantPopupHeight = this.variantPopup.offsetHeight;
        const titleContainerHeight = this.titleContainer.offsetHeight;
        const resultHeight = variantPopupHeight - titleContainerHeight;

        // Storing the result in a CSS variable
        document.documentElement.style.setProperty("--popup-content-height",`${resultHeight}px`);
      }

      attachCloseVariantPopupListener() {
        const closeButton = document.querySelector("variant-close-button");

        if(!closeButton) return;
        closeButton.addEventListener("click", () => {
          document.body.classList.remove("overflow-hidden","popup-overlay");
          this.popupWrapper.classList.remove("active-popup");
          // Reintializing the load state for the product variant popup
          this.popupWrapper.innerHTML = this.initialSectionHTML;
        });
      }

      showVariantsPopup(event) {
        event.preventDefault();

        this.initalizeVariantsPopup();

        //section rendering api call to render the product variant popup
        const sectionName = "product-form-popup";
        const productHandle = this.closest("marmeto-product-card").dataset.productHandle;

        fetch(`/products/${productHandle}?sections=${sectionName}`)
          .then((response) => response.json())
          .then((responseJson) => {
            const htmlString = responseJson["product-form-popup"];
            const html = new DOMParser().parseFromString(htmlString,"text/html");

            const popupContainer = document.querySelector("variant-popup");
            popupContainer.innerHTML = html.body.innerHTML;

            this.calculatePopupContainerHeight();
            this.attachCloseVariantPopupListener();
          })
          .catch((error) => console.error("Error rendering section:", error));
      }
    }
  );
}